import { render, staticRenderFns } from "./notificationCenter.vue?vue&type=template&id=dc204764&scoped=true&"
import script from "./notificationCenter.vue?vue&type=script&lang=js&"
export * from "./notificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./notificationCenter.vue?vue&type=style&index=0&id=dc204764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc204764",
  null
  
)

export default component.exports